import * as React from 'react';

import { useTranslation } from 'react-i18next';

import bannerImg from '@assets/images/nomad/shop_banner.webp';

import { Button } from '@components/button';

import * as Styled from './shop.styled';

const Shop = () => {
	const { t } = useTranslation('nomad');

	return (
		<Styled.Wrapper>
			<Styled.MainTitle>{t('home_title_4')}</Styled.MainTitle>
			<Styled.Container>
				<Styled.Content>
					<Styled.Title>{t('home_desc_4')}</Styled.Title>
					<Styled.LinkStyled to='/shop'>
						<Button color='primary'>{t('home_btn_4')}</Button>
					</Styled.LinkStyled>
				</Styled.Content>
				<Styled.ImageWrapper>
					<img src={bannerImg} alt='quests banner' />
				</Styled.ImageWrapper>
			</Styled.Container>
		</Styled.Wrapper>
	);
};

export default Shop;
